import { render, staticRenderFns } from "./previewBg.vue?vue&type=template&id=801d30ce"
import script from "./previewBg.vue?vue&type=script&lang=ts"
export * from "./previewBg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports